import { render } from "./UpdatesGraph.vue?vue&type=template&id=3b006560"
import script from "./UpdatesGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatesGraph.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Graphs/UpdatesGraph.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b006560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b006560', __exports__)) {
    api.reload('3b006560', __exports__)
  }
  
  module.hot.accept("./UpdatesGraph.vue?vue&type=template&id=3b006560", () => {
    api.rerender('3b006560', render)
  })

}


export default __exports__